import Marquee from "react-fast-marquee";

export const MarqueeBar = ({ dark = false }) => (
  <div className={`${dark ? "bg-secondary" : "bg-primary"} py-4 border-y-2 border-border overflow-hidden`} data-testid="marquee-bar">
    <Marquee speed={60} gradient={false}>
      {Array.from({ length: 6 }).map((_, i) => (
        <span key={i} className={`font-anton text-2xl md:text-3xl uppercase tracking-tighter mx-6 ${dark ? "text-white" : "text-primary-foreground"}`}>
          Unlimited Gear <span className="text-white">//</span> Punk <span className="text-white">//</span> Sports <span className="text-white">//</span> Fitness <span className="text-white">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);
